const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export default clamp;